import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import * as _ from 'lodash';

import { CuttingMaterial, CuttingPanelBaseSlot } from 'cloud-shared-lib';
import { Observable, tap, timer } from 'rxjs';
import { SvgWorkspaceComponent } from '../../../../components/svg-workspace/svg-workspace.component';
import { CuttingPanelOutline, PlateTypeEnum } from '../../../../models/cutting/cutting-panel-outline.model';
import { CuttingPanelSlot } from '../../../../models/cutting/cutting-panel-slot.model';
import { CuttingPanel } from '../../../../models/cutting/cutting-panel.model';
import { Grooves } from '../panel-outline-editor-dialog.component';

@Component({
  selector: 'csl-groove-form',
  templateUrl: './groove-form.component.html',
  styleUrls: ['./groove-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class GrooveFormComponent implements OnInit, OnChanges {
  @Input() editable = true;
  @Input() panel: CuttingPanel;
  @Input() material: CuttingMaterial;

  @Output() formChanged: EventEmitter<Grooves> = new EventEmitter();

  @ViewChild('svgWorkspace', { static: true }) svgWorkspace: SvgWorkspaceComponent;

  fullPanelThickness: number;

  render$: Observable<number>;

  get outline(): CuttingPanelOutline<CuttingPanelBaseSlot> {
    return this.panel.panelOutline;
  }

  constructor() {}

  ngOnInit(): void {
    this.formChanged.subscribe(() => {
      this.svgWorkspace.draw(this.panel);
    });

    /* TODO: Т к раньше это делалось в ngAfterViewChecked, это очень перегружало основной поток и вызывало циклические рендеры,
     * чтобы ничего не поломать и снизить нагрузку добавлен этот костыль,
     * но перерисовку все равно необходимо переделать, чтобы схема перерисовывалась только при реальных изменениях в панели
     */
    this.render$ = timer(0, 1000).pipe(
      tap(() => {
        this.redraw();
      })
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.material?.currentValue) {
      this.fullPanelThickness = this.getFullPanelThickness();
    }
  }

  redraw(): void {
    this.svgWorkspace.draw(this.panel);
  }

  getGrooves(): Grooves {
    return {
      top: this.outline.topSide.groove,
      bottom: this.outline.bottomSide.groove,
      left: this.outline.leftSide.groove,
      right: this.outline.rightSide.groove,
    };
  }

  setPlate(groove: CuttingPanelSlot, plate: PlateTypeEnum): void {
    if (groove) {
      groove.plate = plate;
      this.formChanged.emit(this.getGrooves());
    }
  }

  getPlate(groove: CuttingPanelSlot): PlateTypeEnum {
    return groove ? groove.plate : PlateTypeEnum.Face;
  }

  setGroove(groove: CuttingPanelSlot, newGroove: CuttingPanelSlot) {
    groove = _.cloneDeep(newGroove);
  }

  getFullPanelThickness(): number {
    return this.panel.panelOutline.faceBanding.reduce((a, v) => a + v.material.thickness, this.material.thickness);
  }
}
